export default defineNuxtPlugin((nuxtApp) => {
  /**
   * 通过访问
   *
   * http://127.0.0.1/test_c300x200.jpg 将会 生成/输出 test.jpg 300x200 的缩略图
   * http://127.0.0.1/test_c300x200.jpg?rot=1 将会 生成/输出 test.jpg 300x200 的缩略图 并90度旋转，=2为180度，=3为270度
   *
   * 其中 c 是生成图片缩略图的参数， 300 是生成缩略图的 宽度 200 是生成缩略图的 高度
   *
   * 一共可以生成2种不同类型的缩略图。
   *
   * 支持 jpeg / png / gif (Gif生成后变成静态图片)
   *
   * C和M  参数按请求宽高比例居中截图图片，然后缩放/放大到指定尺寸（ 图片缩略图大小等于请求的宽高 ）
   *
   * T 和W 参数按请求宽高比例按比例缩放/放大到指定尺寸（ 图片缩略图大小可能小于请求的宽高 )
   */
  /**
   * url 图片url
   * size 尺寸
   * rot 旋转角度
   */
  nuxtApp.provide('getImageSize', (url: string | null, size: string, rot?: number) => {
    if (url && typeof url !== 'string') {
      // url为对象
      return url
    }
    if (!url) {
      // url 不存在
      return ''
    }
    // 检查文件后缀是否为 .mp4
    const extensionIndex = url ? url.lastIndexOf('.') : -1
    const extension = url.slice(extensionIndex).toLowerCase()
    if (extension === '.mp4') {
      return url
    }
    if (extensionIndex === -1)
      return url
    return `${url.slice(0, extensionIndex)}_${size}${url.slice(extensionIndex)}${rot ? `?rot=${rot}` : ''}`
  })
})
